<template>

  <div id="ticketCreate">
    <div class="dialog-content">
      <div class="emergency">If this is an <span class="red-text">emergency</span>, please call your building manager immediately.</div>
      <div class="context">To make a new ticket on behalf of unit, select the property, then type in the unit number. select a ticket type, enter a title, and describe the issue at hand.</div>
    
      <!-- PROPERTY (Using Tickets page)-->
      <v-select
        v-show="$route.name === 'tickets'"
        ref="selectPropertyTickets"
        label="Property"
        prepend-icon="mdi-domain"
        item-text="name"
        item-value="_id"
        :rules="rules.property"
        :items="properties"
        :disabled="properties.length === 1 || $route.name === 'units'"
        v-model="ticket.property"
      ></v-select>

      <!-- PROPERTY (Using Tickets page)-->
      <v-text-field
        v-show="$route.name === 'units'"
        label="Property"
        prepend-icon="mdi-domain"
        disabled
        :rules="rules.property"
        :placeholder="$store.getters.property(ticket.property).name"
      ></v-text-field>
          

      <!-- UNIT (Using Unit Page) -->
      <v-text-field
        v-show="$route.name === 'units'"
        ref="selectUnit"
        label="Unit"
        prepend-icon="mdi-home"
        :rules="rules.unit"
        :items="units"
        disabled
        :placeholder="$store.getters.unit(ticket.unit).title"
      ></v-text-field>
          
      <!-- UNIT (Using Tickets page) -->
      <div class="property-required" :class="{active: ticket.property}">

        <!-- UNIT - Unit Search -->
        <div v-show="useUnitSearch && $route.name === 'tickets'">
          <v-select 
            ref="searchUnit"
            label="Unit"
            prepend-icon="mdi-home"
            autocomplete
            item-text="title"
            item-value="_id"
            :rules="rules.unit"
            v-model="ticket.unit"
            :items="units"
            :search-input.sync="unitSearch"
            :loading="ticket.property && unitsLoading"
          ></v-select>

        </div>

        <div v-show="!useUnitSearch && $route.name === 'tickets'">

          <!-- UNIT - Restricted Units -->
          <v-select 
            ref="selectUnit"
            label="Unit"
            prepend-icon="mdi-home"
            item-text="title"
            item-value="_id"
            :rules="rules.unit"
            v-model="ticket.unit"
            :items="units"
          ></v-select>
        </div>

        <!-- TICKET TAGS -->
        <v-select
          ref="selectTicketTag"
          prepend-icon="mdi-tag"
          label="Ticket Tags"
          chips
          multiple
          item-value="_id"
          item-text="title"
          :rules="rules.type"
          :items="ticketTags"
          v-model="ticket.type"
          @change="$refs.selectTicketTag.blur()"
        >
          <template slot="selection" slot-scope="data">
            <div class="vo-tag">
              <div class="name">{{ data.item.title }}</div>  
              <v-btn class="tag-btn" fab flat small @click="removeTicketTag(data.item, $event)">
                <v-icon>mdi-close</v-icon>
              </v-btn>          
            </div>    
          </template>

        </v-select>

        <!-- TITLE -->
        <v-text-field ref="inputTitle" :rules="rules.title" prepend-icon="mdi-format-title" label="Title" v-model="ticket.title"></v-text-field>

        <!-- DESCRIPTION -->
        <v-text-field ref="inputDescription" :rules="rules.description" prepend-icon="mdi-note-text" no-resize multi-line :rows="3" label="Description" v-model="ticket.body"></v-text-field>

        <vo-image-select ref="imageSelect" :max="5"></vo-image-select>

        <div class="consent-section">
          <div class="consent-context"> In order to serve your request, we require your consent to enter your residence. This is necessary to submit your ticket to us, and for us to proceed. By checking this box, you consent to entry into your unit.</div>
          <v-checkbox class="checkbox" label="I consent" color="primary" v-model="ticket.consent"></v-checkbox>
        </div>

      </div>

    </div>
    <div class="dialog-footer">
      <v-btn class="button" flat color="info" :disabled="lockout.on" @click="routeRemoveQueries(['dialog', 'dialogItem'])">Cancel</v-btn>
      <v-btn class="button" flat color="primary" :loading="lockout.on" @click="create">Create</v-btn>
    </div>
  </div>
</template>

<script>

  import imageUploadMixin from '../mixins/imageUploadMixin.js';
  import permissionMixin  from '../mixins/permissionMixin.js';
  import liveUpdateMixin  from '../mixins/liveUpdateMixin.js';

  export default {
    mixins: [imageUploadMixin, permissionMixin, liveUpdateMixin],
    data () {
      return {
        title: 'New Ticket',
        ticket: {
          property: null,
          unit: null,
          title: '',
          body: '',
          type: [],
          images: [],
          consent: false
        },
        
        units: [],
        unitsLoading: true,
        unitSearch: '',
        useUnitSearch: false,

        rules: {
          property: [
            function (e) {
              return !e ? 'Please select a property.' : true;
            }
          ],
          unit: [
            function (e) {
              return !e ? 'Please select a unit.' : true;
            }
          ],
          type: [
            function (e) {
              return e.length === 0 ? 'Please select at least 1 ticket tag.' : true; 
            }
          ],
          title: [
            function (e) {
              return e.length === 0 || !window.regex.title.test(e) ? 'Please enter a valid title.' : true;
            }
          ],
          description: [
            function (e) {
              return e.length === 0 || !window.regex.description.test(e) ? 'Please enter a valid description.' : true
            }
          ]
        }
      }
    },
    props: {
    
      lockout: {

      },
    
      dialogComponent: {

      }
    
    },
    
    methods: {

      create () {
        if (this.lockout.on) return;
        this.lockout.on = true;

        var textValid = this.validateText();

        if (!textValid) {
          Toast.show('Please correct the highlighted errors.', 'error');
          this.lockout.on = false;
          return;
        }

        var imagesValid = this.validateImages();

        if (!imagesValid) {
          var remove = this.images.length - 5;
          var message = 'Please remove ' + remove + ' image' + (remove === 1 ? '.' : 's.');
          Toast.show(message, 'error');
          this.lockout.on = false;
          return;
        }

        if (!this.ticket.consent) {
          Toast.show('You must give consent for entry to continue.', 'error');
          this.lockout.on = false;
          return;
        }

        var ticket = {
          ...this.ticket,
          status: 'open',
          company: this.$store.getters.company._id
        };

        var returnTicket; // Shouldn't need to make this here

        this.$store.dispatch('createTicket', {
          ticket: ticket
        })
        .then(data => {
          returnTicket = data;

          // Fake a live update to update the list
          this.updateTicketList(data._id);

          if (this.hasPermissions(['unit'])) {
            if (this.app.pages.units.unitTickets && this.app.pages.units.unitTickets.list && this.app.pages.units.selected === returnTicket.unit && this.app.pages.units.unitTickets.list.loaded) {
              this.app.pages.units.unitTickets.list.addItem(returnTicket._id, {unshift: true});
            }
          }

          // UPLOAD IMAGES IF NECESSARY
          var functions = [];
          var d = new Date();

          // IMAGES //
          for (var i = 0; i < this.images.length; ++i) {

            // CONVERT URI TO FORMDATA BLOB
            var blob = this.dataURItoBlob(this.images[i].uri);
            var fd = new FormData(document.forms[0]);
            var filename = d.getTime() + '_' + i + '_ticket';
            fd.append('canvasImage', blob, filename);
            fd.append('width', this.images[i].w);
            fd.append('height', this.images[i].h);

            // APPEND PROMISE //
            functions.push(this.$store.dispatch('addTicketImage', {
              ticket: returnTicket._id, 
              image: fd
            }));
          }

          return Promise.all(functions);
        })
        .then(images => {

          // This is to store that we are waiting for this many images to upload, spinners will show in the ticket details 
          this.$store.commit('storeTickets', [{
            _id: returnTicket._id,
            pendingImages: images.length
          }]);

          this.routeRemoveQueries(['dialog', 'dialogItem']);

          this.app.pages.tickets.selected = returnTicket._id;
          this.$router.push({
            name: 'tickets',
            query: {
              details: returnTicket._id 
            }
          });
          
          this.lockout.on = false;
          Toast.show('Ticket created.', 'success');
        })
        .catch(e => {
          console.log(e);
          this.lockout.on = false;
          Toast.showError(e);
        })
      },

      validateText () {  

        var valid;
        if (this.$route.name === 'tickets')     {
          this.$refs.selectPropertyTickets.validate(true);
          valid = this.$refs.selectPropertyTickets.valid;
          if (!valid) return valid;
        }

        this.$refs.selectTicketTag.validate(true);
        this.$refs.inputTitle.validate(true);
        this.$refs.inputDescription.validate(true);
        
        var unitValid = true;
        if (!this.useUnitSearch) {
          this.$refs.selectUnit.validate(true);
          unitValid = this.$refs.selectUnit.valid;
        }
        else {
          this.$refs.searchUnit.validate(true);
          unitValid = this.$refs.searchUnit.valid;
        }

        return (unitValid && this.$refs.selectTicketTag.valid && this.$refs.inputTitle.valid && this.$refs.inputDescription.valid);
      },

      validateImages () {
        return (this.images.length <= 5);
      },

      removeTicketTag (ticketTag, e) {
        if (e) e.stopPropagation();
        var index = this.ticket.type.indexOf(ticketTag._id);
        if (index >= 0) {
          this.ticket.type.splice(index, 1);
        } 
      }

    },

    computed: {
      
      properties () {
        return this.getAccessiblePropertiesList(['ticket', 'ticketManager', 'ticketAdmin']);
      },

      ticketTags () {
        return _.values(this.$store.getters.ticketTags);        
      },

      images () {
        return this.$refs.imageSelect.images;
      }

    },

    watch: {

      'ticket.property' () {
        if (!this.ticket.property) return;

        // If they are using the Unit page to make this, skip this
        if (this.$route.name === 'units') return;

        // Check to see if they are a building manager/admin in this building
        if (this.hasPermissionsInPropertyRole(['ticket', 'ticketManager', 'ticketAdmin'], this.ticket.property)) {
          this.useUnitSearch = true;

          this.units = [];
          this.unitsLoading = true;
          if (this.ticket.unit) this.ticket.unit = null;

          this.$store.dispatch('loadUnits', {
            company: this.$store.getters.company._id,
            filters: {
              property: this.ticket.property
            }
          })
          .then(data => {
            this.unitsLoading = false;
            this.units = data;
          })
          .catch(e => {
            this.unitsLoading = false;
            console.log(e);
            Toast.showError(e);
          });
        }
        else {
          this.useUnitSearch = false;
          var units = this.getUnitsWithPermissions(['ticket'], this.ticket.property);
          var populatedUnits = [];
          units.forEach(u => {
            populatedUnits.push(this.$store.getters.unit(u));
          });

          if (populatedUnits.length === 1) {
            this.ticket.unit = populatedUnits[0];
          }
          this.units = populatedUnits;
        }

      },

      unitSearch: _.debounce(function () { 
        if (!this.ticket.property) return;
        this.unitsLoading = true;
        
        this.$store.dispatch('loadUnits', {
          company: this.$store.getters.company._id,
          filters: {
            property: this.ticket.property,
            search: this.unitSearch
          }
        })
        .then(data => {
          this.units = data;
          this.unitsLoading = false;
        })
        .catch(e => {
          console.log(e);
          Toast.showError(e);
          this.unitsLoading = false;
        })

      }, 200)
    
    },

    created () {
      if (this.$route.name === 'tickets' && this.app.pages.tickets.filtering.filters.property.value !== 'all') {
        this.ticket.property = this.app.pages.tickets.filtering.filters.property.value;
      }
      else if (this.$route.name === 'units') {
        var items = this.$route.query.dialogItem.split(',');
        this.ticket.property  = items[0];
        this.ticket.unit      = items[1];
      }
      this.$emit('title', this.title);
    }
  }

</script>

<style lang="scss">

  @import '../css/global.scss';

  #ticketCreate {
    position: relative;

    .dialog-content {
      padding: 16px;
    }

    .emergency {
      text-align: center;
      @include fontPrimary500;
      margin: 0 0 16px;

      .red-text {
        color: $error_red;
      }
    }

    .property-required {
      pointer-events: none;
      opacity: .24;

      &.active {
        opacity: 1;
        pointer-events: auto;
      }
    }

    .consent-section {
      @include fontPrimary400();

      padding: 24px 16px 0 40px;
      border-top: $borderBlack12;
      color: $black54;

      .consent-context {
        font-size: 14px;
      }

      .checkbox {
        width: 105px;
        margin: 16px auto;
      }
    }

  }

</style>


// WEBPACK FOOTER //
// src/components/TicketCreate.vue